import React, { useEffect, useState, forwardRef } from 'react';
import { FormFieldConfig } from '../../Hooks/useForm';
import { getGuid } from '../../Utils/stringUtils';
import './biz-input.scss';

export type BizTextAreaProps = {
	onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
	onBlur?: (e: React.FocusEvent<HTMLTextAreaElement>) => void;
	onKeyUp?: (e: React.KeyboardEvent<HTMLTextAreaElement>) => void;
	value: string;
	name?: string;
	placeholder?: string;
	className?: string;
	formConfig?: FormFieldConfig<string>;
	readonly?: boolean;
	disabled?: boolean;
	legacy?: boolean;
	rows?: number;
};

const BizTextArea = forwardRef<HTMLTextAreaElement, BizTextAreaProps>(
	(
		{ onChange, onBlur, onKeyUp, value, placeholder, className, formConfig, name: pName, readonly, disabled, legacy, rows },
		ref
	) => {
		const [name] = useState(pName ?? getGuid());
		const isValid = formConfig?.state.fields[name]?.isValid ?? true;

		useEffect(() => {
			if (!formConfig || !formConfig.validators) return;

			const newIsValid = formConfig.state.validateFieldValue(value, formConfig.validators);
			if (newIsValid !== isValid) {
				formConfig.state.setFieldValid(name, newIsValid, formConfig.group);
			}
		}, [value, formConfig?.validators]);

		function handleChange(e: React.ChangeEvent<HTMLTextAreaElement>) {
			onChange(e);
			if (formConfig && !formConfig.state.isDirty) {
				formConfig.state.setDirty();
			}
		}

		function handleBlur(e: React.FocusEvent<HTMLTextAreaElement>) {
			if (onBlur) {
				onBlur(e);
			}
		}

		function handleKeyUp(e: React.KeyboardEvent<HTMLTextAreaElement>) {
			if (onKeyUp) {
				onKeyUp(e);
			}
		}

		let currentClasses = `biz-input-surface ${className ?? ''}`;
		if (!isValid) {
			currentClasses += ' invalid';
		}

		if (!legacy) {
			currentClasses += ' biz-input';
		}

		return (
			<textarea
				ref={ref}
				className={currentClasses}
				placeholder={placeholder}
				value={value}
				name={name}
				onChange={handleChange}
				readOnly={readonly}
				disabled={disabled}
				rows={rows}
				onBlur={handleBlur}
				onKeyUp={handleKeyUp}
			/>
		);
	}
);

export default BizTextArea;
